export function auditStamp() {
  const clean = (value) =>
    value && !["undefined", "null"].includes(value) ? value : "";
  return {
    createdAt: new Date().toISOString(),
    authorId: clean(localStorage.getItem("userId")),
    author:
      [
        clean(localStorage.getItem("firstname")),
        clean(localStorage.getItem("lastname")),
      ]
        .filter(Boolean)
        .join(" ") ||
      clean(localStorage.getItem("userEmail")) ||
      clean(localStorage.getItem("name")) ||
      "Auteur non renseigné",
  };
}
export function auditDate(value) {
  if (!value) return "Date non renseignée";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "Date non renseignée"
    : date.toLocaleString("fr-FR", { timeZone: "Europe/Paris", hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit", year: "numeric" });
}
